import "../style/page/cashback.scss";
import { useEffect, useState, useMemo } from "react";
import { appointmentdetails } from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import noimage from "../../assets/images/noimage.png";
import pdf from "../../assets/images/pdf.png";
import { sidebar } from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { Chart } from "react-google-charts";
import noimage1 from "../../assets/images/noimage.png";

export default function AppoinmentDetails(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [data, setdata] = useState([]);
  const dispatch = useDispatch();
  const [doctorcount, setdoctorcount] = useState(0);
  const [appoinmentcount, setappoinmentcount] = useState(0);
  const [gender, setgender] = useState("all");
  const locationid = useSelector(
    (state) => state.counter.loginuser_location_id
  );

  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91"
  );

  const [ageit, setageit] = useState("0");
  const [agegt, setagegt] = useState("120");
  const [datadownloadstate, setdatadownload] = useState("False");
  const [appointStatus, setAppointStatus] = useState("all");
  let roledata = localStorage.getItem("role");
  const [pieChartData, setPieChartData] = useState({
    pending: 2,
    cancel: 4,
    completed: 2,
  });
  // for pie chart
  const pie_chart_data = [
    ["Appointment", "count"],
    ["Pending", pieChartData.pending],
    ["Cancel", pieChartData.cancel],
    ["Completed", pieChartData.completed],
  ];
  const options = {
    title: "Appointment status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      //   0: { color: "lite-blue" },
      2: { color: "green" },
    },
  };

  var today = new Date();
  // var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);
  const [range, setrange] = useState([gt, it]);
  useEffect(() => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: appointmentdetails,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        date_gt: range[0],
        date_lt: range[1],
        page: dtpageindex,
        page_size: dtpagesize,
        doctor_name: searchQuery,
        gender: gender,
        location: branches,
        age_lt: ageit != "" ? ageit : "0",
        age_gt: agegt != "" ? agegt : "120",
        generate_excel: datadownloadstate,
        appointstatus: appointStatus,
      },
    })
      .then((res) => {
        console.log(res.data.data);
        // setdata(res.data.data);
        let piedata = {
          pending: res.data.data.pending,
          cancel: res.data.data.cancel,
          completed: res.data.data.completed,
        };
        console.log(piedata, "test");
        setPieChartData(piedata);
        if (res.data.data.data != undefined) {
          settableheaderdata(res.data.data.data);
        } else {
          window.open(res.data.data);
        }
        setdatadownload("False");
        setdatacount(res.data.data_count);
        setdoctorcount(
          "₹" +
            parseFloat(res.data.data.amount_paid)
              .toFixed(0)
              .replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
        );
        setappoinmentcount(res.data.data.appointment_count);
        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }, [
    range,
    dtpageindex,
    dtpagesize,
    searchQuery,
    gender,
    branches,
    ageit,
    agegt,
    datadownloadstate,
    appointStatus,
  ]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];

  const columns = useMemo(
    () => [
      {
        Header: "Created date",
        accessor: "",

        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Bill ID",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id.slice(-12)}
              >
                {String(row.row.original.id).slice(-12)}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(row.row.original.id).slice(-12));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Doctor Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.doctor.first_name
                  )}
                >
                  {String(row.row.original.doctor.first_name)}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    "Ph.No:" + row.row.original.patient.phonenumber
                  )}
                >
                  {String(
                    row.row.original.patient.first_name +
                      " " +
                      row.row.original.patient.last_name
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Patient Ph.No",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.patient.phonenumber
                  )}
                >
                  {String(row.row.original.patient.phonenumber)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.patient.p_uhid)}
                >
                  {String(row.row.original.patient.p_uhid)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.status)}
                >
                  {row.row.original.status == "0" ? (
                    <p style={{ color: "blue", fontWeight: 700 }}>Pending</p>
                  ) : row.row.original.status == "1" ? (
                    <p style={{ color: "red", fontWeight: 700 }}>Canceled</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Completed</p>
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Amount Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.appointmentbookrazorpay.appointment_amount
                  )}
                >
                  {row.row.original.appointmentbookrazorpay
                    .appointment_amount == null
                    ? "--"
                    : "₹" +
                      row.row.original.appointmentbookrazorpay
                        .appointment_amount}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Razor pay ID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.appointmentbookrazorpay
                      .appointment_order_id
                  )}
                >
                  {row.row.original.appointmentbookrazorpay
                    .appointment_order_id == null
                    ? "--"
                    : row.row.original.appointmentbookrazorpay
                        .appointment_order_id}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.appointmentbookrazorpay.isPaid
                  )}
                >
                  {row.row.original.appointmentbookrazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "VisitDate",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.visit_date)}
                >
                  {String(row.row.original.visit_date)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "VisitTime",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.visit_slot)}
                >
                  {String(row.row.original.visit_slot)}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "Final Report",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <img
                  style={{
                    height: "2.5rem",
                    width: "2.5rem",
                    // borderRadius: "50%",
                  }}
                  onClick={(e) => {
                    {
                      row.row.original.prescription_pdf_file_media != null &&
                        window.open(
                          row.row.original.prescription_pdf_file_media != null
                            ? row.row.original.prescription_pdf_file_media
                                .file_url
                            : ""
                        );
                    }
                  }}
                  className="pointer"
                  src={
                    row.row.original.prescription_pdf_file_media != null
                      ? /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(
                          String(
                            row.row.original.prescription_pdf_file_media
                              .file_url
                          )
                        )
                        ? row.row.original.prescription_pdf_file_media.file_url
                        : pdf
                      : noimage
                  }
                ></img>
              </span>
            </>
          );
        },
      },
      {
        Header: "Doctor Prescription",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.upload_pes_doc &&
              row.row.original.upload_pes_doc.length > 0 ? (
                row.row.original.upload_pes_doc.map((ele) => {
                  {
                    /* console.log(ele,"testajh") */
                  }
                  return (
                    <>
                      <a href={ele ? ele : noimage} target="_blank">
                        <img
                          style={{
                            height: "2.5rem",
                            width: "2.5rem",
                            borderRadius: "50%",
                            margin: "4px",
                          }}
                          src={ele ? ele : noimage1}
                        ></img>
                      </a>
                    </>
                  );
                })
              ) : (
                <>
                  <a href={noimage} target="_blank">
                    <img
                      style={{
                        height: "2.5rem",
                        width: "2.5rem",
                        borderRadius: "50%",
                        margin: "4px",
                      }}
                      src={noimage1}
                    ></img>
                  </a>
                </>
              )}
            </>
          );
        },
      },
      {
        Header: "Patient Uploaded",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.media_url &&
              row.row.original.media_url.length > 0 ? (
                row.row.original.media_url.map((ele) => {
                  {
                    /* console.log(ele,"testajh") */
                  }
                  return (
                    <>
                      <a href={ele ? ele : noimage} target="_blank">
                        <img
                          style={{
                            height: "2.5rem",
                            width: "2.5rem",
                            borderRadius: "50%",
                            margin: "4px",
                          }}
                          src={ele ? ele : noimage1}
                        ></img>
                      </a>
                    </>
                  );
                })
              ) : (
                <>
                  <a href={noimage} target="_blank">
                    <img
                      style={{
                        height: "2.5rem",
                        width: "2.5rem",
                        borderRadius: "50%",
                        margin: "4px",
                      }}
                      src={noimage1}
                    ></img>
                  </a>
                </>
              )}
            </>
          );
        },
      },
      {
        Header: "Visit Type",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={
                    String(row.row.original.type) == 0
                      ? "Online"
                      : "Hospital Visit"
                  }
                >
                  {String(row.row.original.type) == 0
                    ? "Online"
                    : "Hospital Visit"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Video Call Attended",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={
                    row.row.original.type == 0
                      ? row.row.original.doc_not_attend == false
                        ? "NO"
                        : row.row.original.status == "2" &&
                          row.row.original.doc_not_attend == true
                        ? "YES"
                        : "NO"
                      : "--"
                  }
                >
                  {row.row.original.type == 0
                    ? row.row.original.doc_not_attend == false
                      ? "NO"
                      : row.row.original.status == "2" &&
                        row.row.original.doc_not_attend == true
                      ? "YES"
                      : "NO"
                    : "--"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Automatic Cancel",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={
                    row.row.original.automatic_cancel == false ? "NO" : "YES"
                  }
                >
                  {row.row.original.automatic_cancel == false ? "NO" : "YES"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Visit Token",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={row.row.original.visit_token}
                >
                  {row.row.original.visit_token}
                </div>
              </span>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const datadownload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want To Download The Data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setdatadownload("True");
      } else {
        setdatadownload("False");
      }
    });
  };
  return (
    <>
      <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
        <div class="page-header">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Appointments Details</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Appointments Details</li>
              </ul>
            </div>
            <div class="col-sm-5 col-auto">
              {" "}
              <div className="datepicker_dash">
                <DateRangePicker
                  defaultValue={[
                    // new Date(new Date().setDate(today.getDate() - 30)),
                    new Date(),
                    new Date(),
                  ]}
                  // disabledDate={(date) => isAfter(date, new Date())}
                  editable={false}
                  appearance="default"
                  placement="bottomEnd"
                  size="lg"
                  ranges={predefinedBottomRanges}
                  placeholder="From - To"
                  style={{ width: 270, padding: 10, float: "right" }}
                  onClean={(e) => cleaningrange(e)}
                  onChange={(e) => {
                    if (e != null) {
                      setrange([]);
                      e.forEach((newValue) => {
                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                        var localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate("validtill", localISOTime);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body" style={{ padding: "1.5rem" }}>
              <div
                align="center"
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <a
                  class="dnbtn"
                  onClick={(e) => {
                    datadownload();
                  }}
                ></a>
              </div>
              <div
                className="row pt-4"
                style={{ justifyContent: "space-between" }}
              >
                <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-primary border-primary">
                          <i class="bi bi-cash-coin"></i>
                        </span>
                        <div class="dash-count">
                          <h3>{doctorcount != NaN ? doctorcount : ""}</h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Amount Paid</h6>
                        {/* <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${doctorcount / 10}%` }}
                            aria-valuenow={doctorcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-sm-6 col-12 pie_chart">
                  <Chart
                    chartType="PieChart"
                    data={pie_chart_data}
                    options={options}
                    width={"400px"}
                    height={"250px"}
                  />
                </div>
              </div>

              <form
                onSubmit={handleSubmit}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div
                  class="input-group rounded"
                  style={{ width: "250px", height: "40px" }}
                >
                  <input
                    type="search"
                    class="form-control rounded"
                    aria-label="Search"
                    aria-describedby="search-addon"
                    value={searchQuery}
                    onKeyDown={(e) => {
                      if (e.target.value.length === 0 && e.which === 32) {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) => {
                      if (e.target.value.length <= "100") {
                        setSearchQuery(e.target.value);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="10"
                    label="Search"
                    placeholder="Search..."
                    required
                  />
                  <span
                    class="input-group-text border-0 bg-transparent"
                    id="search-addon"
                  >
                    <i
                      class="bi bi-search"
                      style={{
                        color: "#1b5a90",
                        width: "20px",
                        height: "20px",
                      }}
                    ></i>
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label class="mr-2">From Age</label>
                    <input
                      type="number"
                      class="form-control mr-2"
                      style={{ width: "60px" }}
                      onWheel={(e) => {
                        document.activeElement.blur();
                      }}
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      placeholder="Age"
                      value={ageit}
                      onChange={(e) => {
                        if (e.target.value <= 120) {
                          setageit(e.target.value);
                        }
                      }}
                    ></input>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label class="mr-2">To Age</label>

                    <input
                      type="number"
                      class="form-control mr-2"
                      style={{ width: "60px" }}
                      onWheel={(e) => {
                        document.activeElement.blur();
                      }}
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      placeholder="Age"
                      value={agegt}
                      onChange={(e) => {
                        if (e.target.value <= 120) {
                          setagegt(e.target.value);
                        }
                      }}
                    ></input>
                  </div>
                  <div
                    class="input-group rounded mr-2 "
                    style={{
                      width: "250px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <label class="mr-2">Gender</label>
                    <select
                      class="form-select"
                      value={gender}
                      name="gender"
                      onChange={(e) => {
                        setgender(e.target.value);
                      }}
                    >
                      <option selected disabled value="">
                        Filter By Gender...
                      </option>
                      <option value={"all"}>All</option>
                      <option value={"0"}>Male</option>
                      <option value={"1"}>Female</option>
                      <option value={"2"}>Others</option>
                      <option value={"3"}>Decline to State</option>
                    </select>
                  </div>

                  {/* <div
                    class="input-group rounded mr-2 "
                    style={{ width: "250px", height: "40px", display: "flex", alignItems: "center" }}
                  >
                    <label class="mr-2">Branch</label>
                    <select
                      class="form-select"
                      value={branches}
                      name="gender"
                      onChange={(e) => {
                        setbranches(e.target.value);
                      }}
                    >
                      <option selected disabled value="">
                        Filter By Location...
                      </option>
                      <option value={"all"}>All</option>
                      <option value={"0"}>VELACHERY</option>
                      <option value={"1"}>CHETPET</option>
                      <option value={"2"}>KOLATHUR</option>
                    </select>
                  </div> */}
                  {/* for status  */}
                  <div
                    class="input-group rounded mr-2 "
                    style={{
                      width: "250px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <label class="mr-2">Appointment Status</label>
                    <select
                      class="form-select"
                      value={appointStatus}
                      name="gender"
                      onChange={(e) => {
                        setAppointStatus(e.target.value);
                      }}
                    >
                      <option selected disabled value="">
                        Filter By Status...
                      </option>
                      <option value={"all"}>All</option>
                      <option value={"0"}>Pending</option>
                      <option value={"1"}>Cancel</option>
                      <option value={"2"}>Completed</option>
                    </select>
                  </div>
                </div>
              </form>
              <div className="table-responsive">
                <BasicTable
                  columns={columns}
                  data={tableheaderdata}
                  pagesize={pagesize}
                  pageindex={pageindex}
                  dtpagesize={dtpagesize}
                  dtpageindex={dtpageindex}
                  datacount={datacount}
                  location={"others"}
                  setbranches={setbranches}
                  branches={branches}
                />
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="appoinment"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={50}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}
